import { render, staticRenderFns } from "./Modules12.vue?vue&type=template&id=44bb13ea"
import script from "./Modules12.vue?vue&type=script&lang=js"
export * from "./Modules12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports